import { CarrierAndServiceSchema } from "@redotech/redo-model/fulfillments/fulfillment-carriers-and-services";
import * as z from "zod/v4";
import { null as zNull } from "zod/v4";

export const getTeamCarrierServiceOptions = {
  name: "getTeamCarrierServiceOptions" as const,
  input: zNull(),
  output: z.object({ options: z.array(CarrierAndServiceSchema) }),
};
